// @flow
import { fork } from 'redux-saga/effects';
import setCardTable from './setCardGame';
import getCurrentGameTableRef from './getCurrentGameTableRef';
import getSimilars from './getSimilar';
import setGameWrong from './gameWrong';
import reset from './reset';
// eslint-disable-next-line import/no-named-as-default
import getMistakes from './getMistakes';
// eslint-disable-next-line import/no-named-as-default
import getCardColor from './getCardColor';
// eslint-disable-next-line import/no-named-as-default
import updateCardColor from './updateCardColor';
// eslint-disable-next-line import/no-named-as-default
import getHeroColor from './getHeroColor';
// eslint-disable-next-line import/no-named-as-default
import updateHeroColor from './updateHeroColor';

export default function* gameSaga() {
  yield fork(setCardTable);
  yield fork(getCurrentGameTableRef);
  yield fork(getSimilars);
  yield fork(setGameWrong);
  yield fork(getMistakes);
  yield fork(reset);
  yield fork(getCardColor);
  yield fork(updateCardColor);
  yield fork(getHeroColor);
  yield fork(updateHeroColor);
}
